class AnnouncementCountdown extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.endDateStr = this.getAttribute('data-date');
    if (!this.endDateStr) return;
    
    // Replace space with T to make it ISO compliant for cross-browser parsing (e.g. Safari)
    const formattedDateStr = this.endDateStr.trim().replace(' ', 'T');
    this.endDate = new Date(formattedDateStr).getTime();
    if (isNaN(this.endDate)) return;

    this.timeElement = this.querySelector('.announcement-bar__countdown-time');

    this.textHour = this.getAttribute('data-text-hour') || 'HORA';
    this.textHours = this.getAttribute('data-text-hours') || 'HORAS';
    this.textMinute = this.getAttribute('data-text-minute') || 'MINUTO';
    this.textMinutes = this.getAttribute('data-text-minutes') || 'MINUTOS';
    this.textSecond = this.getAttribute('data-text-second') || 'SEGUNDO';
    this.textSeconds = this.getAttribute('data-text-seconds') || 'SEGUNDOS';

    this.updateCountdown();
    this.interval = setInterval(() => this.updateCountdown(), 1000);
  }

  disconnectedCallback() {
    if (this.interval) clearInterval(this.interval);
  }

  updateCountdown() {
    const now = new Date().getTime();
    const distance = this.endDate - now;

    if (distance < 0) {
      if (this.timeElement) {
        this.timeElement.innerHTML = `0 ${this.textHours} : 00 ${this.textMinutes} : 00 ${this.textSeconds}`;
      }
      clearInterval(this.interval);
      return;
    }

    const days = Math.floor(distance / (1000 * 60 * 60 * 24));
    const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)) + (days * 24);
    const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((distance % (1000 * 60)) / 1000);

    const hoursLabel = hours === 1 ? this.textHour : this.textHours;
    const minutesLabel = minutes === 1 ? this.textMinute : this.textMinutes;
    const secondsLabel = seconds === 1 ? this.textSecond : this.textSeconds;

    const minutesStr = minutes < 10 ? '0' + minutes : minutes;
    const secondsStr = seconds < 10 ? '0' + seconds : seconds;

    if (this.timeElement) {
      this.timeElement.innerHTML = `${hours} ${hoursLabel} : ${minutesStr} ${minutesLabel} : ${secondsStr} ${secondsLabel}`;
    }
  }
}

if (!customElements.get('announcement-countdown')) {
  customElements.define('announcement-countdown', AnnouncementCountdown);
}
